<template>
  <div class="home">
    <div class="banner container">
      <el-carousel trigger="click" height="350px">
        <el-carousel-item v-for="(item, index) in banner" :key="index">
          <a :href="item.link" :target="item.target" @click="clickBanner(index)"><img :src="item.url" alt="模来模往" /></a>

        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="home_links">
      <div class="container flex_sb">
        <div class="links_box" id="outsourcing">
          <div class="title">
            <img src="@/assets/images/icon-link1.png" />外协招标
          </div>
          <div class="des">多家报价 图纸保密</div>
          <div class="btn">
            <router-link tag="a" :to="{ name: 'SetEnquiry' }">立即比价</router-link>
          </div>
        </div>
        <div class="links_box">
          <div class="title">
            <img src="@/assets/images/icon-link2.png" />工厂直供
          </div>
          <div class="des">优选产品 品质保障</div>
          <div class="btn">
            <a href>立即发布</a>
          </div>
        </div>
        <div class="links_box">
          <div class="title">
            <img src="@/assets/images/icon-link3.png" />发布需求
          </div>
          <div class="des">智能匹配100万优质供应商</div>
          <div class="btn">
            <router-link tag="a" :to="{ name: 'DemandSquare' }">立即发布</router-link>
          </div>
        </div>
        <div class="links_box">
          <div class="title">
            <img src="@/assets/images/icon-link4.png" />搜索工厂
          </div>
          <div class="des">全方位验厂展示 多维度产能筛选</div>
          <div class="btn">
            <router-link tag="a" :to="{ name: 'Search' }">立即搜索</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="home_factory">
      <div class="container flex_sb">
        <div id="taskMonth" class="home_echarts"></div>
        <div id="QuarterChart" class="home_echarts"></div>
      </div>
      <br />
      <div class="container flex_sb">
        <div id="jyChart" class="home_echarts"></div>
        <div id="cooperationChart" class="home_echarts"></div>
      </div>
    </div>
    <div class="home_factory">
      <h2 class="home_title">模具云工厂</h2>
      <div class="home_xian"></div>
      <div class="container tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="模具供应商" name="first">
            <div class="container">
              <div class="home_factory_cont flex_sb">
                <div class="home_factory_box" v-for="(item, index) in supplier" :key="index">
                  <router-link tag="a" :to="{
                    name: 'FactoryInfo',
                    query: {
                      id: item.id, // orderNum : this.searchData.orderNo
                      type: '模具厂',
                    }
                  }">
                    <div class="pic">
                      <img :src="getImagesUrl(item)" />
                    </div>
                    <div class="info">
                      <div class="title">
                        <h2>{{ item.tenancyName }}</h2>
                        <p>
                          <span>产值：{{ item.outputValue_display }}</span>
                          <span v-if="!!item.jobStartYear">成立于{{ item.jobStartYear }}年</span>
                        </p>
                      </div>
                      <div class="explain">
                        <h3>加工特长</h3>
                        <p>{{ item.specialSkill }}</p>
                      </div>
                      <div class="explain">
                        <h3>加工工艺</h3>
                        <div class="crafts">
                          <span v-for="(type, index) in item.processTypes" :key="index">{{ type }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="机加工工厂" name="second">
            <div class="container">
              <div class="home_factory_cont flex_sb">
                <div class="home_factory_box" v-for="(item, index) in factory" :key="index">
                  <router-link tag="a" :to="{
                    name: 'FactoryInfo',
                    query: {
                      id: item.id, // orderNum : this.searchData.orderNo
                      type: '云加工点',
                    }
                  }">
                    <div class="pic">
                      <img :src="getImagesUrl(item)" />
                    </div>
                    <div class="info">
                      <div class="title">
                        <h2>{{ item.tenancyName }}</h2>
                        <p>
                          <span>产值：{{ item.outputValue_display }}</span>
                          <span v-if="!!item.jobStartYear">成立于{{ item.jobStartYear }}年</span>
                        </p>
                      </div>
                      <div class="explain">
                        <h3>工艺类型</h3>
                        <div class="crafts">
                          <span v-for="(type, index) in item.processTypes.slice(0, 5)" :key="index">{{ type }}</span>
                        </div>
                      </div>
                      <div class="explain">
                        <p>{{ item.specialSkill }}</p>
                      </div>
                      <div class="timely">
                        <div class="timely_box">
                          <span>{{ item.reportRate + '%' || '暂无' }}</span>
                          <span>报工率</span>
                        </div>
                        <div class="timely_box">
                          <span>{{ item.delayEndRate + '%' || '暂无' }}</span>
                          <span>延迟率</span>
                        </div>
                        <div class="timely_box">
                          <span>{{ item.overHourRate + '%' || '暂无' }}</span>
                          <span>超时率</span>
                        </div>
                        <div class="timely_box">
                          <span>{{ item.ontimeStartRate + '%' || '暂无' }}</span>
                          <span>准时率</span>
                        </div>
                      </div>
                    </div>
                  </router-link>

                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="模具供应链" name="third">
            <div class="container">
              <div class="home_factory_cont flex_sb">
                <div class="home_factory_box" v-for="(item, index) in supply" :key="index">
                  <router-link tag="a" :to="{
                    name: 'FactoryInfo',
                    query: {
                      id: item.id, // orderNum : this.searchData.orderNo
                      type: '云供应链',
                    }
                  }">
                    <div class="pic">
                      <img :src="getImagesUrl(item)" />
                    </div>
                    <div class="info">
                      <div class="title">
                        <h2>{{ item.tenancyName }}</h2>
                        <p>
                          <span>产值：{{ item.outputValue_display }}</span>
                          <span v-if="!!item.jobStartYear">成立于{{ item.jobStartYear }}年</span>
                        </p>
                      </div>
                      <div class="explain">
                        <h3>加工特长</h3>
                        <p>{{ item.specialSkill }}</p>
                      </div>
                    </div>
                  </router-link>

                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="home_partner">
      <div class="container tabs">
        <h2>云模型</h2>
        <el-tabs v-model="activeModel">
          <el-tab-pane label="3D打印" name="first">
            <el-row type="flex">
              <el-col :span="12" class="models-part">
                <ul class="flex models-ul">
                  <li class="item" v-for="(item, index) in modelsArr1.data" :key="index"
                    @mouseenter="moveModels(modelsArr1, item, index)" @click="mouldsInfo(item.id)">
                    <img :src="item.img.slice(0, 1)" :alt="item.name" />
                    <div class="nicheng" :class="{ 'isActive': item.isActive }">
                      <div class="nicheng-msg">
                        <h3 v-text="item.name"></h3>
                        <p v-text="item.color"></p>
                      </div>
                    </div>
                  </li>
                  <li class="more" @click="goModelsIndex">
                    <div class="nicheng">
                      <i class="el-icon-more"></i>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" class="models-part">
                <ul v-if="modelsArr1.data" class="models-img">
                  <li v-for="item in modelsArr1.data[modelsArr1.activeItem].img" :key="item.id">
                    <img :src="item" />
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" style="background:white;" class="models-msgs">
                <div class="models-msg" v-if="modelsArr1.data">
                  <h4
                    v-text="modelsArr1.data[modelsArr1.activeItem].name + ' ' + modelsArr1.data[modelsArr1.activeItem].color">
                  </h4>
                  <ol>
                    <li v-if="modelsArr1.data[modelsArr1.activeItem].characteristic">
                      <span>特性</span>
                      <p v-text="modelsArr1.data[modelsArr1.activeItem].characteristic"></p>
                    </li>
                    <li v-if="modelsArr1.data[modelsArr1.activeItem].advantage">
                      <span>优点</span>
                      <p v-text="modelsArr1.data[modelsArr1.activeItem].advantage"></p>
                    </li>
                    <li v-if="modelsArr1.data[modelsArr1.activeItem].shortcoming">
                      <span>缺点</span>
                      <p v-text="modelsArr1.data[modelsArr1.activeItem].shortcoming"></p>
                    </li>
                  </ol>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="金属打样及批量" name="second">
            <el-row type="flex">
              <el-col :span="12" class="models-part">
                <ul class="flex models-ul">
                  <li class="item" v-for="(item, index) in modelsArr2.data" :key="index"
                    @mouseenter="moveModels(modelsArr2, item, index)" @click="mouldsInfo(item.id)">
                    <img :src="item.img.slice(0, 1)" :alt="item.name" />
                    <div class="nicheng" :class="{ 'isActive': item.isActive }">
                      <div class="nicheng-msg">
                        <h3 v-text="item.name"></h3>
                        <p v-text="item.color"></p>
                      </div>
                    </div>
                  </li>
                  <li class="more" @click="goModelsIndex">
                    <div class="nicheng">
                      <i class="el-icon-more"></i>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" class="models-part">
                <ul v-if="modelsArr2.data" class="models-img">
                  <li v-for="item in modelsArr2.data[modelsArr2.activeItem].img" :key="item.id">
                    <img :src="item" />
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" style="background:white;" class="models-msgs">
                <div class="models-msg" v-if="modelsArr2.data">
                  <h4
                    v-text="modelsArr2.data[modelsArr2.activeItem].name + ' ' + modelsArr2.data[modelsArr2.activeItem].color">
                  </h4>
                  <ol>
                    <li v-if="modelsArr2.data[modelsArr2.activeItem].characteristic">
                      <span>特性</span>
                      <p v-text="modelsArr2.data[modelsArr2.activeItem].characteristic"></p>
                    </li>
                    <li v-if="modelsArr2.data[modelsArr2.activeItem].advantage">
                      <span>优点</span>
                      <p v-text="modelsArr2.data[modelsArr2.activeItem].advantage"></p>
                    </li>
                    <li v-if="modelsArr2.data[modelsArr2.activeItem].shortcoming">
                      <span>缺点</span>
                      <p v-text="modelsArr2.data[modelsArr2.activeItem].shortcoming"></p>
                    </li>
                  </ol>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="模具制造" name="third">
            <el-row type="flex">
              <el-col :span="12" class="models-part">
                <ul class="flex models-ul">
                  <li class="item" v-for="(item, index) in modelsArr3.data" :key="index"
                    @mouseenter="moveModels(modelsArr3, item, index)" @click="mouldsInfo(item.id)">
                    <img :src="item.img.slice(0, 1)" :alt="item.name" />
                    <div class="nicheng" :class="{ 'isActive': item.isActive }">
                      <div class="nicheng-msg">
                        <h3 v-text="item.name"></h3>
                        <p v-text="item.color"></p>
                      </div>
                    </div>
                  </li>
                  <li class="more" @click="goModelsIndex">
                    <div class="nicheng">
                      <i class="el-icon-more"></i>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" class="models-part">
                <ul v-if="modelsArr3.data" class="models-img">
                  <li v-for="item in modelsArr3.data[modelsArr3.activeItem].img" :key="item.id">
                    <img :src="item" />
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" style="background:white;" class="models-msgs">
                <div class="models-msg" v-if="modelsArr3.data">
                  <h4
                    v-text="modelsArr3.data[modelsArr3.activeItem].name + ' ' + modelsArr3.data[modelsArr3.activeItem].color">
                  </h4>
                  <ol>
                    <li v-if="modelsArr3.data[modelsArr3.activeItem].characteristic">
                      <span>特性</span>
                      <p v-text="modelsArr3.data[modelsArr3.activeItem].characteristic"></p>
                    </li>
                    <li v-if="modelsArr3.data[modelsArr3.activeItem].advantage">
                      <span>优点</span>
                      <p v-text="modelsArr3.data[modelsArr3.activeItem].advantage"></p>
                    </li>
                    <li v-if="modelsArr3.data[modelsArr3.activeItem].shortcoming">
                      <span>缺点</span>
                      <p v-text="modelsArr3.data[modelsArr3.activeItem].shortcoming"></p>
                    </li>
                  </ol>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="大批量注塑" name="fourth">
            <el-row type="flex">
              <el-col :span="12" class="models-part">
                <ul class="flex models-ul">
                  <li class="item" v-for="(item, index) in modelsArr4.data" :key="index"
                    @mouseenter="moveModels(modelsArr4, item, index)" @click="mouldsInfo(item.id)">
                    <img :src="item.img.slice(0, 1)" :alt="item.name" />
                    <div class="nicheng" :class="{ 'isActive': item.isActive }">
                      <div class="nicheng-msg">
                        <h3 v-text="item.name"></h3>
                        <p v-text="item.color"></p>
                      </div>
                    </div>
                  </li>
                  <li class="more" @click="goModelsIndex">
                    <div class="nicheng">
                      <i class="el-icon-more"></i>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" class="models-part">
                <ul v-if="modelsArr4.data" class="models-img">
                  <li v-for="item in modelsArr4.data[modelsArr4.activeItem].img" :key="item.id">
                    <img :src="item" />
                  </li>
                </ul>
              </el-col>
              <el-col :span="6" style="background:white;" class="models-msgs">
                <div class="models-msg" v-if="modelsArr4.data">
                  <h4
                    v-text="modelsArr4.data[modelsArr4.activeItem].name + ' ' + modelsArr4.data[modelsArr4.activeItem].color">
                  </h4>
                  <ol>
                    <li v-if="modelsArr4.data[modelsArr4.activeItem].characteristic">
                      <span>特性</span>
                      <p v-text="modelsArr4.data[modelsArr4.activeItem].characteristic"></p>
                    </li>
                    <li v-if="modelsArr4.data[modelsArr4.activeItem].advantage">
                      <span>优点</span>
                      <p v-text="modelsArr4.data[modelsArr4.activeItem].advantage"></p>
                    </li>
                    <li v-if="modelsArr4.data[modelsArr4.activeItem].shortcoming">
                      <span>缺点</span>
                      <p v-text="modelsArr4.data[modelsArr4.activeItem].shortcoming"></p>
                    </li>
                  </ol>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="home_partner">
      <div class="container">
        <h2>合作伙伴</h2>
        <div class="home_partner_list">
          <ul>
            <li>
              <a href="#">
                <img src="@/assets/images/cus1.jpg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/images/cus2.jpg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/images/cus3.jpg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/images/cus4.jpg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/images/cus11.jpg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/images/cus6.jpg" />
              </a>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/images/cus12.jpg" />
              </a>
            </li>
            <li>
              <a href="#" target="_blank">
                <img src="@/assets/images/cus9.jpg" />
              </a>
            </li>
            <li>
              <a href="http://adsale.hk/2545-CPS22-131" target="_blank"><!-- http://adsale.hk/11147-CPS21-190 -->
                <img src="@/assets/images/cus17.jpg" />
              </a>
            </li>
            <li>
              <a href="http://adsale.hk/2545-CPS22-131" target="_blank">
                <img src="@/assets/images/cus15.jpg" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog title="imouldSourcing2021" :visible.sync="imouldSourcing" width="1200px" top="40px" center>
      <!-- <div class="demo-image__lazy">
  <el-image v-for="url in urls" :key="url" :src="url" :lazy=true>
    <div slot="error" class="image-slot">
        <el-image :src="url"></el-image>
      </div>
  </el-image>
</div> -->
      <iframe src="/2mould.com/index.html" frameborder="0" width="100%" height="800px" style="margin:-25px auto"></iframe>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import moment from "moment";
import { homeEcharts } from "@/api/manage.js";
import { dateFormat, toFixed } from "@/utils/date.js"


export default {
  name: "Home",
  components: {},
  data() {
    return {
      urls: [],
      imouldSourcing: false,
      activeName: "first",
      activeModel: "first",
      code: "",
      supplier: [
        {
          id: 1121,
          type: '模具厂',
          tenancyName: "台州市黄岩星泰塑料模具有限公司",
          outputValue_display: "大于1亿",
          jobStartYear: "1999",
          processTypes: ["数控铣", "深孔钻", "五轴深孔钻", "五轴高速铣"],
          specialSkill:
            "汽车仪表板（包括微孔发泡）注塑模、保险杠注塑模、门板类叠层注塑模、大型双色（包括水平旋转）注塑模、高光塑件注塑模、低压注塑模、窗框饰条注塑模、薄壁塑件注塑模、油箱吹塑模等。",
          img: require("@/assets/images/about1.jpg")
        },
        {
          id: 1164,
          type: '模具厂',
          tenancyName: "浙江精诚模具机械有限公司",
          outputValue_display: "1000~5000万",
          jobStartYear: "1989",
          processTypes: ["数控铣", "深孔钻", "五轴深孔钻", "精雕"],
          specialSkill:
            "致力于平模头及挤出生产线配套设备领域的研发生产与技术应用，产品囊括薄膜模头系列，板片材模头系列，中空板模头系列，涂覆模头系列，多层模内共挤模头，熔喷非织造布模头系列，分配器，静态混合器,共挤吹膜模头系列",
          img: require("@/assets/images/about2.jpg")
        },
        {
          id: 233,
          type: '模具厂',
          tenancyName: "浙江台州美多模具有限公司",
          outputValue_display: "1000~5000万",
          jobStartYear: "1999",
          processTypes: ["数控铣", "深孔钻", "五轴深孔钻", "电火花"],
          specialSkill:
            "空调、冰箱、洗衣机等白色家电，高档办公用品，汽车内外饰件等产品的注塑模具",
          img: require("@/assets/images/about3.jpg")
        },
        {
          id: 561,
          type: '模具厂',
          tenancyName: "浙江赛豪模具有限公司",
          outputValue_display: "1000~5000万",
          jobStartYear: "1994",
          processTypes: ["五轴深孔钻", "五轴深孔钻", "电火花"],
          specialSkill:
            "致力于车灯模具,内外饰件模具,门板模具,保险杠模具,仪表台模具,倒车镜模具,汽车车灯模具等汽车模具",
          img: require("@/assets/images/about4.jpg")
        }
      ],

      factory: [
        {
          id: 219,
          type: '云加工点',
          tenancyName: "万和数控铣",
          outputValue_display: "大于100万小于500万",
          jobStartYear: "2019",
          processTypes: ["数控铣", "深孔钻", "精雕", "线切割", "慢走丝"],
          specialSkill: "专业高速铣",
          reportRate: "100",
          delayEndRate: "66",
          overHourRate: "0",
          ontimeStartRate: "33",
          img: require("@/assets/images/about5.jpg")
        },
        {
          id: 1290,
          type: '云加工点',
          tenancyName: "台州市黄岩万泰/宏特精工模具有限公司",
          outputValue_display: "小于100万",
          jobStartYear: "2016",
          processTypes: ["高速铣", "精雕", "中走丝", "抛光", "冲床"],
          specialSkill:
            "模具加工配套服务为和核心业务，专注于高档精密模具加工，致力于为全球优秀模具企业提供优质的加工配套服务",
          reportRate: "100",
          delayEndRate: "0",
          overHourRate: "0",
          ontimeStartRate: "33",
          img: require("@/assets/images/about6.jpg")
        },
        {
          id: 275,
          type: '云加工点',
          tenancyName: "李积良",
          outputValue_display: "小于100万",
          jobStartYear: "1999",
          processTypes: ["高速铣", "线切割", "钻床", "精飞", "大型卧铣"],
          specialSkill: "数控铣，高速铣加工",
          reportRate: "100",
          delayEndRate: "20",
          overHourRate: "0",
          ontimeStartRate: "80",
          img: require("@/assets/images/about7.jpg")
        },
        {
          id: 213,
          type: '云加工点',
          tenancyName: "红旗小余高速铣",
          outputValue_display: "小于100万",
          jobStartYear: "1994",
          processTypes: ["高速铣", "飞刀", "激光焊", "锯床", "热处理"],
          specialSkill:
            "1、致力于高品质的模具多工序加工 2、规范管理、质量把控、持续改进、满足需求",
          reportRate: "100",
          delayEndRate: "10",
          overHourRate: "0",
          ontimeStartRate: "90",
          img: require("@/assets/images/about8.jpg")
        }
      ],

      supply: [
        {
          id: 991,
          type: '云供应链',
          tenancyName: "台州市黄岩奇泓智能科技有限公司",
          outputValue_display: "500-1000万",
          jobStartYear: "2009",
          specialSkill:
            "机器人 机械手 模内贴标系列 注塑自动化一站式服务、非标个性化定制、非标机械手、口罩机自动化等",
          img: require("@/assets/images/about9.jpg")
        },
        {
          id: 1001,
          type: '云供应链',
          tenancyName: "乔治费歇尔精密机床（上海）有限公司",
          outputValue_display: "500-1000万",
          jobStartYear: "2002",
          specialSkill:
            "销售：瑞士GF米克朗高速铣，阿奇夏米尔精密慢丝，镜面火花机，激光皮纹机等模具加工设备。",
          img: require("@/assets/images/about10.jpg")
        },
        {
          id: 1072,
          type: '云供应链',
          tenancyName: "台州市黄岩建成模钢有限公司",
          outputValue_display: "500-1000万",
          jobStartYear: "1996",
          specialSkill:
            "专业生产各类优质锻件、模具钢、加工、销售45#钢，P20H、718、H13、P20等各种模具钢材。",
          img: require("@/assets/images/about11.jpg")
        },
        {
          id: 1373,
          type: '云供应链',
          tenancyName: "马路科技",
          outputValue_display: "500-1000万",
          jobStartYear: "1996",
          specialSkill:
            "过去20所累积的RE(逆向工程)+RP(3D打印)、CAV与Deformation等技术经验，加上目前的核心业务“3D打印+3D扫描”及DMG高阶五轴雷射加工机",
          img: require("@/assets/images/about12.jpg")
        }
      ],
      banner: [
        { url: require("@/assets/images/banner1.jpg"), link: "#", target: "" },
        { url: require("@/assets/images/banner2.jpg"), link: "#", target: "_blank" },
        { url: require("@/assets/images/banner3.jpg"), link: "#", target: "" },
        { url: require("@/assets/images/banner4.jpg"), link: "#", target: "" },
        { url: require("@/assets/images/banner8.jpg"), link: "http://adsale.hk/11147-CPS21-189", target: "_blank" },
        { url: require("@/assets/images/banner6.jpg"), link: "#", target: "" },
        { url: require("@/assets/images/banner7.jpg"), link: "http://www.dmcexpo.com", target: "_blank" },
        { url: require("@/assets/images/banner10.jpg"), link: "http://adsale.hk/2545-CPS22-129", target: "_blank" },
      ],
      modelsArr1: [],
      modelsArr2: [],
      modelsArr3: [],
      modelsArr4: []
    };
  },

  methods: {
    getEchartsData() {
      let _this = this;
      var type;
      var processTypesArr = [
        "全部",
        "数控铣",
        "高速铣",
        "深孔钻",
        "精雕",
        "电火花",
        "合模"
      ];
      var taskMonth = echarts.init(document.getElementById("taskMonth"));
      var option = {
        tooltip: {
          trigger: "axis"
        },
        color: ["#3e8deb"],
        legend: {
          textStyle: {
            color: "#000"
          },
          //left: "right",
          data: ["任务数"]
        },
        xAxis: [
          {
            type: "category",
            data: ["19/06"],
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            }
          }
        ],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          containLabel: true
        },
        yAxis: [
          {
            nameLocation: "start",
            type: "value",
            name: "",
            nameTextStyle: {
              color: "#000",
              fontSize: 16
            },
            splitLine: { show: false }, //去除网格线
            nameGap: 25,
            axisLine: {
              //show: false,
              lineStyle: {
                color: "#000"
              }
            }
          }
        ]
      };

      taskMonth.setOption(option);
      var index = 0;
      function getTaskData() {
        //let timeNow = new Date().Format("yyyy-MM-dd");
        let timeNow = dateFormat("yyyy-MM-dd", new Date());
        var monthXAxis = [];
        var seriesData = [];
        let dateArr = [];
        let cnc_milling = [];
        let deep_hole_drilling = [];
        let edm_arr = [];
        let high_speed_milling = []
        var type = processTypesArr[index];
        index < processTypesArr.length - 1 ? index++ : (index = 0);
        _this.$http
          .get(
            "/v1/api/statistics/platformdashboard/getcommondimensionhistory",
            { //startDate=2019-01-01&endDate=2023-04-04&datedimension=3&keys=taskfee&=数控铣,电火花,深孔钻,高速铣
              params: {
                startDate: "2021-10-01",
                endDate: timeNow,
                datedimension: "3",
                keys: "taskfee",
                subkeys: "数控铣,电火花,深孔钻,高速铣",
              }
            }
          )
          .then(res => {
            var hadDate = false;
            if (res.result.length == 5) { //初始化产能分析数据
              hadDate = true;
              res.result[0]?.filter(val => {
                return val != "date" ? dateArr.push(val.split(" ")[0]) : false;
              });
              cnc_milling = res.result[1]?.slice(1, res.result[1].length);
              deep_hole_drilling = res.result[2]?.slice(1, res.result[2].length);
              edm_arr = res.result[3]?.slice(1, res.result[3].length);
              high_speed_milling = res.result[4]?.slice(1, res.result[4].length);
            }
            //当返回没有数据时，进行随机选择是否展示
            /*res.result.result.forEach(el => {
              if (el.taskCount) {
                hadDate = true;
              }
              monthXAxis.unshift(String(el.year) + "/" + String(el.month));
              seriesData.unshift(el.taskCount);
            });
            */
            if (!hadDate && Math.random() > 0.8) {
              getTaskData();
              return;
            }
            setData(res.result.totalTaskCount); //修改
            //setTimeout(getTaskData, 6000)//修改
          });
        setData(); //修改
        function setData(total) {
          var optionData = {
            title: {
              //    text: type + '活跃度，总数：' + total,//修改
              text: "交易总额",
              textStyle: { color: "#000" }
            },
            color: ["#01c4d9", "#015ed9", "#343B40", "#FE710E"],
            legend: {
              textStyle: { color: "#000" },
              data: ["数控铣", "高速铣", "深孔钻", "电火花"]
            },
            xAxis: [
              {
                type: "category",
                data: dateArr,
                axisPointer: {
                  type: "shadow"
                },
                axisLine: {
                  lineStyle: {
                    color: "#000"
                  }
                }
              }
            ],
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            series: [
              {
                name: "数控铣",
                type: "line",
                smooth: true,
                itemStyle: {
                  borderWidth: 3
                  //borderColor: '#01c4d9',
                },
                lineStyle: {
                  width: 3
                  //color: '#01c4d9',
                },
                data: cnc_milling,
              },
              {
                name: "深孔钻",
                type: "line",
                smooth: true,
                itemStyle: {
                  borderWidth: 3
                  //borderColor: '#01c4d9',
                },
                lineStyle: {
                  width: 3
                  //color: '#01c4d9',
                },
                data: deep_hole_drilling,
              },
              {
                name: "电火花",
                type: "line",
                smooth: true,
                itemStyle: {
                  borderWidth: 3
                  //borderColor: '#01c4d9',
                },
                lineStyle: {
                  width: 3
                  //color: '#01c4d9',
                },
                data: edm_arr,
              },
              {
                name: "高速铣",
                type: "line",
                smooth: true,
                itemStyle: {
                  borderWidth: 3
                  //borderColor: '#01c4d9',
                },
                lineStyle: {
                  width: 3
                  //color: '#01c4d9',
                },
                data: high_speed_milling,
              },
            ]
          };
          taskMonth.setOption(optionData);
        }
      }
      getTaskData();
    },
    setQuarter() {
      var QuarterChart = echarts.init(document.getElementById("QuarterChart"));
      let timeNow = dateFormat("yyyy-MM-dd", new Date());
      //api/statistics/platformdashboard/getcommondimensionhistory?startdate=2023-04-01&enddate=2023-04-04&datedimension=1&keys=taskcount,reportcount
      this.$http.get("/v1/api/statistics/platformdashboard/getcommondimensionhistory", {
        params: {
          startdate: "2021-1-1",
          enddate: timeNow,
          datedimension: 3,
          keys: "taskcount,reportcount,taskdelayrate,taskoutrate"
        },
      }).then(res => {
        let _dateArr = [];
        let taskcount = [];
        let reportcount = [];
        let taskdelayrate = [];
        let taskoutrate = [];
        if (res.result.length == 5) { //初始化产能分析数据
          res.result[0]?.filter(val => {
            return val != "date" ? _dateArr.push(val.split(" ")[0]) : false;
          });
          taskcount = res.result[1]?.slice(1, res.result[1].length);
          reportcount = res.result[2]?.slice(1, res.result[2].length);
          taskdelayrate = res.result[3]?.slice(1, res.result[3].length);
          taskoutrate = res.result[4]?.slice(1, res.result[4].length);
        }
        var option = {
          title: {
            text: "产能分析",
            textStyle: { color: "black" }
          },
          tooltip: {
            //鼠标移上去显示toolbox
            trigger: "axis"
          },
          color: ["#00B578", "#1492FF", "#D93026", "#FFB71F"],
          legend: {
            textStyle: { color: "#000" },
            data: ["加工发包总数", "报工总数", "精益率", "协作率"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: _dateArr,
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            }
          },
          yAxis: [{
            type: "value",
            splitNumber: 5,
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgb(255 255 255 / 30%)",
              },
            }, // 去除网格线
            axisLine: {
              show: true,
              lineStyle: {
                type: "solid",
                // color: "#2BE9FF",
                color: "#000000",
              },
            },
            axisTick: {
              show: false, // 坐标轴刻度线
            },
            axisLabel: {
              textStyle: {
                // color: "#2BE9FF", //坐标值得具体的颜色
                color: "#333333",
              },
            },
          },
          {
            type: "value",
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgb(255 255 255 / 30%)",
              },
            }, // 去除网格线
            axisLine: {
              show: false,
              lineStyle: {
                type: "solid",
                // color: "#2BE9FF",
                color: "#000000",
              },
            },
            axisTick: {
              show: false, // 坐标轴刻度线
            },
            axisLabel: {
              textStyle: {
                // color: "#2BE9FF", //坐标值得具体的颜色
                color: "#333333",
              },
            },
            max: 1,
          }
          ],
          series: [
            {
              name: "加工发包总数",
              type: "line",
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#01c4d9',
              },
              lineStyle: {
                width: 3
                //color: '#01c4d9',
              },
              data: taskcount,
            },
            {
              name: "报工总数",
              type: "line",
              data: reportcount,
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            },
            {
              name: "精益率",
              type: "line",
              smooth: true,
              yAxisIndex: 1,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#01c4d9',
              },
              lineStyle: {
                width: 3
                //color: '#01c4d9',
              },
              data: taskoutrate.map(val => toFixed(1 - val / 100, 2)),
            },
            {
              name: "协作率",
              type: "line",
              yAxisIndex: 1,
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#01c4d9',
              },
              lineStyle: {
                width: 3
                //color: '#01c4d9',
              },
              data: taskdelayrate.map(val =>
                toFixed(val / 100, 2)
              ),
            },
          ],
          textStyle: {
            color: "#000"
          }
        };
        QuarterChart.setOption(option);
      });
    },
    setQuarter3() {
      var QuarterChart = echarts.init(document.getElementById("jyChart"));
      this.$http.get("/v2/Echars", {}).then(res => {
        for (let i = 0; i < res.chars2.length; i++) {
          res.chars2[i].skx_ph = res.chars2[i].skx_ph.toFixed(2);
          res.chars2[i].skx_jy = res.chars2[i].skx_jy.toFixed(2);
          res.chars2[i].gsx_ph = res.chars2[i].gsx_ph.toFixed(2);
          res.chars2[i].gsx_jy = res.chars2[i].gsx_jy.toFixed(2);
          res.chars2[i].skz_ph = res.chars2[i].skz_ph.toFixed(2);
          res.chars2[i].skz_jy = res.chars2[i].skz_jy.toFixed(2);
          res.chars2[i].dhh_ph = res.chars2[i].dhh_ph.toFixed(2);
          res.chars2[i].dhh_jy = res.chars2[i].dhh_jy.toFixed(2);
        }
        var option = {
          title: {
            text: "精益指数",
            textStyle: { color: "black" }
          },
          tooltip: {
            //鼠标移上去显示toolbox
            trigger: "axis"
          },
          color: ["#01c4d9", "#015ed9", "#343B40", "#FE710E"],
          legend: {
            textStyle: { color: "#000" },
            data: ["数控铣", "高速铣", "深孔钻", "电火花"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: res.chars2.map(el => String(el.time)),
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            }
          },
          yAxis: {
            type: "value",
            nameTextStyle: {
              color: "#000",
              fontSize: 16
            },
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            }
          },
          series: [
            {
              name: "数控铣",
              type: "line",
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#01c4d9',
              },
              lineStyle: {
                width: 3
                //color: '#01c4d9',
              },
              data: res.chars2.map(el => el.skx_jy)
            },
            {
              name: "高速铣",
              type: "line",
              data: res.chars2.map(el => el.gsx_jy),
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            },
            {
              name: "深孔钻",
              type: "line",
              data: res.chars2.map(el => el.skz_jy),
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            },
            {
              name: "电火花",
              type: "line",
              data: res.chars2.map(el => el.dhh_jy),
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            }
          ],
          textStyle: {
            color: "#000"
          }
        };
        QuarterChart.setOption(option);
      });
    },
    setQuarter4() {
      var cooperationChart = echarts.init(
        document.getElementById("cooperationChart")
      );
      this.$http.get("/v2/Echars", {}).then(res => {
        for (let i = 0; i < res.chars2.length; i++) {
          res.chars2[i].skx_ph = res.chars2[i].skx_ph.toFixed(2);
          res.chars2[i].skx_jy = res.chars2[i].skx_jy.toFixed(2);
          res.chars2[i].gsx_ph = res.chars2[i].gsx_ph.toFixed(2);
          res.chars2[i].gsx_jy = res.chars2[i].gsx_jy.toFixed(2);
          res.chars2[i].skz_ph = res.chars2[i].skz_ph.toFixed(2);
          res.chars2[i].skz_jy = res.chars2[i].skz_jy.toFixed(2);
          res.chars2[i].dhh_ph = res.chars2[i].dhh_ph.toFixed(2);
          res.chars2[i].dhh_jy = res.chars2[i].dhh_jy.toFixed(2);
        }
        var cooperationOption = {
          title: {
            text: "协作指数",
            textStyle: { color: "black" }
          },
          tooltip: {
            //鼠标移上去显示toolbox
            trigger: "axis"
          },
          color: ["#01c4d9", "#015ed9", "#343B40", "#FE710E"],
          legend: {
            textStyle: { color: "#000" },
            data: ["数控铣", "高速铣", "深孔钻", "电火花"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            data: res.chars2.map(el => String(el.time)),
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            }
          },
          yAxis: {
            type: "value",
            nameTextStyle: {
              color: "#000",
              fontSize: 16
            },
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            }
          },
          series: [
            {
              name: "数控铣",
              type: "line",
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#01c4d9',
              },
              lineStyle: {
                width: 3
                //color: '#01c4d9',
              },
              data: res.chars2.map(el => el.skx_ph)
            },
            {
              name: "高速铣",
              type: "line",
              data: res.chars2.map(el => el.gsx_ph),
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            },
            {
              name: "深孔钻",
              type: "line",
              data: res.chars2.map(el => el.skz_ph),
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            },
            {
              name: "电火花",
              type: "line",
              data: res.chars2.map(el => el.dhh_ph),
              smooth: true,
              itemStyle: {
                borderWidth: 3
                //borderColor: '#015ed9',
              },
              grid: {
                bottom: "0",
                containLabel: true
              },
              lineStyle: {
                width: 3
                //color: '#015ed9',
              }
            }
          ],
          textStyle: {
            color: "#000"
          }
        };
        cooperationChart.setOption(cooperationOption);
      });
    },
    getCompanyData() {
      let _this = this;
      this.$http
        .get(
          "/v1/api/services/app/mesTenancy/GetPageResult?page=1&limit=10&keyword=&where=%20%20(TenancyName%3D%3D%22浙江精诚模具机械有限公司%22%20%7C%7C%20TenancyName%3D%3D%22浙江台州美多模具有限公司%22%20%7C%7C%20TenancyName%3D%3D%22浙江赛豪实业有限公司%22%20%7C%7C%20TenancyName%3D%3D%22台州市黄岩星泰塑料模具有限公司%22)&searchKeys=%7B%22form%22:%22Ignore%22,%22jcbdz%22:%22Yun-2mould%22,%22nameType%22:%22%E6%A8%A1%E5%85%B7%E5%8E%82%22,%22MainEquipment%22:%22%22%7D"
        )
        .then(res => {
          this.supplier = res.data;//修改

        });
      this.$http
        .get(
          "/v1/api/services/app/mesTenancy/GetPageResult?page=1&limit=10&keyword=&where=%20%20(TenancyName%3D%3D%22台州市黄岩奇泓智能科技有限公司%22%20%7C%7C%20TenancyName%3D%3D%22乔治费歇尔精密机床（上海）有限公司%22%20%7C%7C%20TenancyName%3D%3D%22建成模具钢%22%20%7C%7C%20TenancyName%3D%3D%22马路科技%22)&searchKeys=%7B%22form%22:%22Ignore%22,%22jcbdz%22:%22Yun-2mould%22,%22nameType%22:%22%E4%BA%91%E4%BE%9B%E5%BA%94%E9%93%BE%22,%22MainEquipment%22:%22%22%7D"
        )
        .then(res => {
          this.supply = res.data;//修改

        });
      this.$http
        .get(
          "/v1/api/services/app/mesTenancy/GetPageResult?page=1&limit=10&keyword=&where=%20%20(TenancyName%3D%3D%22台州市黄岩万泰/宏特精工模具有限公司%22%20%7C%7C%20TenancyName%3D%3D%22万和数控铣%22%20%7C%7C%20TenancyName%3D%3D%22红旗小余高速铣%22%20%7C%7C%20TenancyName%3D%3D%22李积良%22)&searchKeys=%7B%22form%22:%22Ignore%22,%22jcbdz%22:%22Yun-2mould%22,%22nameType%22:%22%E4%BA%91%E5%8A%A0%E5%B7%A5%E7%82%B9%22,%22MainEquipment%22:%22%22%7D"
        )
        .then(res => {
          this.factory = res.data;//修改
        });
      for (let i = 0; i < 4; i++) {
        var id = 0;
        switch (i) {
          case 0:
            id = 219;
            break;
          case 1:
            id = 1290;
            break;
          case 2:
            id = 275;
            break;
          case 3:
            id = 213;
            break;
        }
        this.$http
          .get("/v1/api/services/app/mesTenancy/getById?primary=" + id)
          .then(res => {
            this.factory[i].reportRate = res.result.reportRate;
            this.factory[i].delayEndRate = res.result.delayEndRate;
            this.factory[i].overHourRate = res.result.overHourRate;
            this.factory[i].ontimeStartRate = res.result.ontimeStartRate;
            this.factory[i].processTypes = res.result.processTypes;
            this.factory[i].specialSkill =
              res.result.processorInfo.specialSkill;
            this.factory[i].jobStartYear = res.result.jobStartYear;
          });
      }
    },
    moveModels(obj, item, index) {
      Vue.delete(obj.data[obj.activeItem], "isActive");
      Vue.set(item, "isActive", true);
      obj.activeItem = index;
    },
    mouldsInfo(e) {
      this.$router.push({
        name: "ModelsPage",
        query: {
          id: e
        }
      });
    },
    goModelsIndex() {
      this.$router.push({ name: 'ModelsIndex' })
    },
    getImagesUrl(e) {
      if (e.mainEquipment != null) {
        if (!!e.mainEquipment.equipmentPic) {
          var img = e.mainEquipment.equipmentPic.split(',')[0]
          return "v1/File/thumb/" + img + "?w=500"
        } else {
          return require("@/assets/images/about.jpg")
        }
      } else {
        return require("@/assets/images/about.jpg")
      }
      //   return "http://master.itianwang.com/File/thumb/"+e+"?w=500"
    },
    clickBanner(index) {
      console.log(this.urls)
      if (index == 5) {
        this.imouldSourcing = true
      }
    }
  },
  created() {
    for (let i = 0; i < 89; i++) {
      let page = ""
      if (i < 9) {
        page = "0" + (i + 1)
      } else {
        page = "" + (i + 1)
      }
      this.urls.push("https://hy.imould.com/upload/zazhi/xcx/imouldsourcing/xiao/" + page + ".jpg")
    }
    this.code = this.$route.query.code;
    if (this.code != "") {
      this.$http
        .get("/wx/sns/oauth2/access_token?appid=wx5faeeda683cee8cc&secret=e21b7ac350596520b1918b77a68cdb8f&code=" + this.code + "&grant_type=authorization_code")
        .then(res => {
          console.log(res)
        })
        .catch(error => { });


    }

    this.getCompanyData();
    this.$http
      .get("/v2/GetMoulds")
      .then(res => {
        this.modelsArr1 = { data: res.data.moulds_3d, activeItem: 0 };
        this.modelsArr2 = { data: res.data.moulds_dy, activeItem: 0 };
        this.modelsArr3 = { data: res.data.moulds_make, activeItem: 0 };
        this.modelsArr4 = { data: res.data.moulds_injection, activeItem: 0 };
      })
      .catch(error => { });
  },
  mounted() {
    this.getEchartsData();
    this.setQuarter();
    this.setQuarter3();
    this.setQuarter4();
  }
};
</script>

<style scoped>
.header_contain {
  padding: 15px 0;
  justify-content: flex-end;
}

.header_contain .logo {
  margin-right: auto;
}

.header_contain .logo img {
  height: 60px;
  padding: 12px 0;
}

.header_contain .nav {
  margin-right: 50px;
}

.header_contain .nav li {
  padding: 0 20px;
}

.header_contain .nav li a {
  position: relative;
  display: inline-block;
  font-size: 16px;
  color: #333;
}

.header_contain .nav li a:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -12px;
  background: #0051a4;
  width: 0;
  height: 3px;
  transition: 0.6s;
}

.header_contain .nav li:hover a {
  color: #0051a4;
}

.header_contain .nav li:hover a:after {
  width: 100%;
}

.quote a {
  display: inline-block;
  padding: 10px 20px;
  background: #0051a4;
  color: #fff;
  font-size: 18px;
  border-radius: 8px;
  transition: 0.4s;
}

.quote a:hover {
  opacity: 0.8;
}

.banner_wrap {
  height: 500px;
}

.swiper-pagination-bullet {
  width: 15px;
  height: 2px;
  background: #000;
  opacity: 1;
  border-radius: 0;
}

.swiper-pagination-bullet-active {
  background: #6cb1db;
}

.banner .swiper-pagination-bullets {
  bottom: 10px;
}

.home_links {
  padding: 50px 0 70px;
}

.links_box {
  width: 24%;
  padding: 20px 15px;
  border: 1px solid #ccc;
  text-align: center;
  border-radius: 2px
}

.links_box:hover {
  border: 1px solid transparent;
  box-shadow: 0 0 12px 0 rgba(61, 37, 144, 0.29);
}

.links_box .title {
  font-size: 24px;
  color: #333;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 12px;
}

.links_box .title img {
  margin-right: 5px;
}

.links_box .btn {
  margin-top: 15px;
}

.links_box .btn a {
  display: inline-block;
  line-height: 32px;
  width: 140px;
  border-radius: 100px;
  border: 1px solid #333;
  color: #333;
}

.links_box .btn a:hover {
  background: #0051a4;
  color: #fff;
}

.home_factory {
  padding: 0px 0 70px;
}

.home_title {
  text-align: center;
  font-size: 24px;
}

.home_xian {
  width: 60px;
  height: 4px;
  background: #0051a4;
  margin: 10px auto 50px;
}

.home_factory_box {
  width: 24%;
  background: #f2f2f2;
  cursor: pointer;
  transition: 0.6s;
}

.home_factory_box .pic {
  height: 180px;
}

.home_factory_box .pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home_factory_box .info {
  padding: 15px 15px 15px;
  text-align: left;
}

.home_factory_box .info .title {
  color: #888;
  font-size: 13px;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 8px;
  width: 100%;
}

.home_factory_box .info .title h2 {
  font-size: 18px;
  color: #222;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.home_factory_box .info .title p {
  display: flex;
  justify-content: space-between;
  margin: 5px 0 8px;
}

.home_factory_box .info .explain {
  width: 100%;
  margin-bottom: 10px;
  color: #7e7e7e;
  font-size: 14px;
  line-height: 1.6;
}

.home_factory_box .info .explain h3 {
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #000;
  text-indent: 5px;
  border-left: 3px solid #0051a4;
  margin-bottom: 6px;
}

.home_factory_box .info .explain p {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  height: 3em;
}

.home_factory_box .info .crafts {
  height: 62px;
}

.home_factory_box .info .crafts span {
  display: inline-block;
  background: #0051a4;
  color: #fff;
  line-height: 26px;
  padding: 0px 12px;
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 3px;
}

.home_factory_box .info .timely {
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding-bottom: 10px;
}

.home_factory_box .info .timely .timely_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home_factory_box .info .timely .timely_box span {
  color: #7e7e7e;
  font-size: 12px;
}

.home_factory_box .info .timely .timely_box span:nth-child(1) {
  color: #0051a4;
  font-size: 18px;
  font-weight: bold;
}

.home_factory_box:hover {
  background: #0051a4;
}

.home_factory_box:hover .pic img {
  opacity: 0.7;
}

.home_factory_box:hover .info .title,
.home_factory_box:hover .info .title h2,
.home_factory_box:hover .info .explain,
.home_factory_box:hover .info .explain h3 {
  color: #eee;
}

.home_factory_box:hover .info .crafts span {
  background: #eee;
  color: #0051a4;
}

.home_factory_box:hover .info .explain h3 {
  border-left: 3px solid #eee;
}

.home_factory_box:hover .info .timely .timely_box span {
  color: #eee;
}

.home_partner {
  padding-bottom: 50px;
}

.home_partner h2 {
  border-left: 5px solid #0051a4;
  text-indent: 10px;
  margin-bottom: 30px;
}

.home_partner_list ul {
  display: flex;
  flex-wrap: wrap;
}

.home_partner_list ul li {
  width: 19%;
  margin-bottom: 10px;
  margin-right: 1.25%;
}

.home_partner_list ul li:nth-child(5n) {
  margin-right: 0;
}

.home_echarts {
  width: 50%;
  height: 235px;
}

.tabs>>>.el-tabs__nav-wrap::after {
  background: white;
}

.tabs>>>.el-tabs__header {
  border: 0;
}

.tabs>>>.el-tabs__nav {
  border: 0;
}

.tabs>>>.el-tabs__item {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;
  border: 0;
  border-bottom: 3px solid transparent;
}

.models-part {
  background: #F3F3F3;
}

.models-ul {
  flex-wrap: wrap;
}

.models-ul li {
  width: calc(100%/3);
  box-sizing: border-box;
  padding: 10px;
  position: relative;
}

.models-ul .nicheng {
  position: absolute;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  top: 10px;
  left: 10px;
  background: rgba(2, 2, 2, 0.5);
  text-align: center;
  cursor: pointer;
}

.models-ul .nicheng .nicheng-msg {
  z-index: 5;
  color: white;
  position: absolute;
  width: 100%;
  bottom: 15px;
}

.models-ul .more .nicheng {
  background: #848999;
}

.models-ul .more .nicheng i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 30px;
}

.models-ul .isActive {
  opacity: 0;
}

.models-img img {
  padding: 10px;
  margin-bottom: 5px;
  height: 210px;
}

.models-msg {
  padding: 10px 20px;
}

.models-msg h4 {
  font-size: 25px;
  color: black;
  margin-bottom: 35px;
}

.models-msg li {
  margin-bottom: 20px;
}

.models-msg li span {
  display: block;
  margin-bottom: 15px;
  font-size: 18px;
  color: black;
}

.models-msgs {
  height: 430px;
  overflow: scroll;
}

::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: rgba(240, 240, 240, 1);
}

::-webkit-scrollbar-track {
  box-shadow: inset000pxrgba(240, 240, 240, .5);
  border-radius: 10px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset000pxrgba(240, 240, 240, .5);
  background-color: rgb(68, 68, 68, 0.6);
}

.demo-image__lazy {
  width: 500px;
  height: 700px;
  overflow: auto;
}

.demo-image__lazy div {
  width: 500px;
  height: 700px;
}

.el-dialog-center {
  margin: 40px auto auto;
}
</style>
